import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex-grow bg-neutral-100" }
const _hoisted_2 = { class: "container mx-auto max-w-6xl" }
const _hoisted_3 = { class: "flex flex-col justify-between mt-8 mb-6 ml-6 sm:flex-row sm:items-center" }
const _hoisted_4 = { class: "text-3xl" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "inline-flex items-center rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium leading-4 text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
}, "All DNS records", -1)
const _hoisted_8 = { class: "bg-white shadow p-6 pb-10 rounded-t" }
const _hoisted_9 = {
  key: 1,
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-2 font-semibold text-2xl clear-right" }, "Question and response", -1)
const _hoisted_14 = { class: "flex flex-col gap-6 lg:flex-row" }
const _hoisted_15 = { class: "min-w-0" }
const _hoisted_16 = { class: "min-w-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-8 mb-2 font-semibold text-2xl" }, "Find the IP addresses for another website or domain name", -1)
const _hoisted_18 = { class: "flex flex-col lg:flex-row" }
const _hoisted_19 = { class: "shrink max-w-xl" }
const _hoisted_20 = {
  class: "mt-3 w-[500px] max-w-full sm:px-6 lg:mt-0",
  autocomplete: "off"
}

import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import axios, { Canceler } from 'axios';
import { domainNameToDisplayName, domainNameToUrlPath, urlPathToDomainName } from '@/common/domainName';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import DomainSearch from '@/components/DomainSearch.vue';
import Alert from '@/components/micro/AlertComponent.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import MetaTags from '@/components/MetaTags.vue';
import SkeletonComponent from '@/components/micro/SkeletonComponent.vue';
import { ApiErrorType, toErrorType } from '@/model/ApiErrorAlert';
import ApiErrorAlert from '@/components/ApiErrorAlert.vue';
import IpAddresses from '@/components/records/IpAddresses.vue';
import {
  QueryResult, WebserversResponse, emptyDnsServer, emptyResponse,
} from '@/model/Api';
import AdUnit from '@/components/ads/AdUnit.vue';
import { WebsiteToIpResultsTop, WebsiteToIpResultsSide, WebsiteToIpResultsBottom } from '@/common/adSlots';


export default /*#__PURE__*/_defineComponent({
  __name: 'WebsiteToIpLookupResults',
  props: {
  routerDomain: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const router = useRouter();

const domain = ref('');
const domainPunycode = ref('');
const loading = ref(true);
const error = ref<ApiErrorType | null>(null);
const showSidebar = ref(window.innerWidth > 991);
const cancelToken = ref<Canceler | null>(null);
const queryResultA = ref<QueryResult>({
  query: {
    server: emptyDnsServer,
    domain: domain.value,
    recordType: 'A',
  },
  response: emptyResponse,
});
const queryResultAaaa = ref<QueryResult>({
  query: {
    server: emptyDnsServer,
    domain: domain.value,
    recordType: 'AAAA',
  },
  response: emptyResponse,
});

function redirectTo(newDomain: string): void {
  router.push(`/domains/${domainNameToUrlPath(newDomain)}/webservers/`);
}

function load() {
  loading.value = true;
  error.value = null;

  if (cancelToken.value) {
    cancelToken.value();
  }
  const axiosSource = axios.CancelToken.source();
  cancelToken.value = axiosSource.cancel;

  axios
    .post<WebserversResponse>('api/v1/webservers', {
      domain: domain.value,
    }, {
      cancelToken: axiosSource.token,
    })
    .then((response) => {
      if (props.routerDomain !== domainNameToUrlPath(response.data.punycodeDomain)) {
        router.replace({
          path: `/domains/${domainNameToUrlPath(response.data.punycodeDomain)}/webservers/`,
        });
      }
      domain.value = domainNameToDisplayName(response.data.unicodeDomain);
      domainPunycode.value = domainNameToDisplayName(response.data.punycodeDomain);
      queryResultA.value = response.data.a;
      queryResultAaaa.value = response.data.aaaa;
      loading.value = false;
    })
    .catch((e) => {
      if (!axios.isCancel(e)) {
        error.value = toErrorType(e.response.data.error);
      }
    });
}

watch(() => props.routerDomain, () => {
  const domainName = urlPathToDomainName(props.routerDomain);
  domain.value = domainName;
  domainPunycode.value = domainName;
  load();
}, {
  immediate: true,
});

window.addEventListener('resize', () => {
  showSidebar.value = window.innerWidth > 991;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: `IP addresses used by ${domain.value}`,
        description: `These are the IPv4 and IPv6 addresses for ${domain.value}, according to the authoritative DNS server.`,
        url: `https://www.nslookup.io/domains/${domainPunycode.value}/webservers/`
      }, null, 8, ["title", "description", "url"])
    ])),
    _createVNode(HeaderComponent, {
      domain: domain.value,
      "domain-search-to-url": (encodedDomain) => `/domains/${encodedDomain}/webservers/`,
      "search-button-text": "Find IP addresses"
    }, null, 8, ["domain", "domain-search-to-url"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createVNode(AdUnit, {
          class: "mx-auto",
          config: _unref(WebsiteToIpResultsTop)
        }, null, 8, ["config"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, [
            _createTextVNode("IP addresses for "),
            (domain.value === domainPunycode.value)
              ? (_openBlock(), _createElementBlock("b", _hoisted_5, _toDisplayString(domain.value), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                  _createElementVNode("b", null, _toDisplayString(domainPunycode.value), 1),
                  _createTextVNode(" (" + _toDisplayString(domain.value) + ")", 1)
                ]))
          ]),
          _createVNode(DnsRecordsLink, {
            domain: domain.value,
            class: "shrink-0 hidden mr-6 sm:block xl:mr-0"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["domain"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(AdUnit, {
            class: "float-right ml-6",
            config: _unref(WebsiteToIpResultsSide)
          }, null, 8, ["config"]),
          (error.value !== null)
            ? (_openBlock(), _createBlock(ApiErrorAlert, {
                key: 0,
                error: error.value,
                domain: domain.value,
                dnsserver: "authoritative"
              }, null, 8, ["error", "domain"]))
            : (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(SkeletonComponent, { class: "w-56 h-8 mb-6" }),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                    return _createElementVNode("div", { key: n }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                        return _createVNode(SkeletonComponent, {
                          key: n,
                          class: "inline-block w-1/2 h-4 pr-[10%] bg-clip-content"
                        })
                      }), 64))
                    ])
                  }), 64)),
                  _createVNode(SkeletonComponent, { class: "inline-block w-56 h-8 my-6" }),
                  _createVNode(SkeletonComponent, { class: "w-24 h-4 mb-2" }),
                  _createVNode(SkeletonComponent, { class: "w-1/2 h-4 mb-6" }),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: n }, [
                      _createVNode(SkeletonComponent, { class: "w-24 h-4 mb-2 block" }),
                      _createVNode(SkeletonComponent, { class: "w-1/2 h-4 mb-2 block" }),
                      _createVNode(SkeletonComponent, { class: "w-1/2 h-4 mb-6" })
                    ], 64))
                  }), 64))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("p", _hoisted_10, "Our DNS servers responded with these IP addresses when we queried it for the domain " + _toDisplayString(domain.value) + ". Some DNS servers may return different IP addresses based on your location.", 1),
                  (queryResultA.value.response.answer.length === 0 && queryResultAaaa.value.response.answer.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(Alert, { type: "warning" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(domain.value), 1),
                              _createTextVNode(" does not have any IP addresses.")
                            ])
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(IpAddresses, {
                        key: 1,
                        "a-records": queryResultA.value,
                        "aaaa-records": queryResultAaaa.value
                      }, null, 8, ["a-records", "aaaa-records"])),
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(RawRecords, { records: queryResultA.value }, null, 8, ["records"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(RawRecords, { records: queryResultAaaa.value }, null, 8, ["records"])
                    ])
                  ])
                ], 64)),
          _createVNode(AdUnit, {
            class: "mt-8 mx-auto",
            config: _unref(WebsiteToIpResultsBottom)
          }, null, 8, ["config"]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, [
              _createTextVNode("With "),
              _createVNode(_component_router_link, {
                to: "/website-to-ip-lookup/",
                class: "text-blue-600 hover:text-blue-800 hover:underline"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("website to IP lookup")
                ]),
                _: 1
              }),
              _createTextVNode(", you can find the IP addresses for any domain name or subdomain. When you enter the domain in the input field below, it will show whether or not IP addresses are configured for that domain.")
            ]),
            _createElementVNode("form", _hoisted_20, [
              _createVNode(DomainSearch, {
                "placeholder-text": "Domain name",
                emphasize: "",
                buttonText: "Find IP addresses",
                prefill: domain.value,
                onSubmitted: redirectTo
              }, null, 8, ["prefill"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})